/*
 * @Description: 
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2023-03-21 16:25:20
 * @LastEditors: Monkey
 * @LastEditTime: 2025-08-22 14:02:14
 */
import config from "@/config"
import http from "@/utils/request"

export default {
  upload: {
    url: `${config.API_URL}/upload/attachment/execute`,
    name: "文件上传",
    post: async function (data, config = {}) {
      config = Object.assign({ codeFlag: true, timeout: 60000 }, config)
      return await http.post(this.url, data, config);
    }
  },
  uploadFile: {
    url: `${config.API_URL}/uploadFile`,
    name: "附件上传",
    post: async function (data, config = {}) {
      return await http.post(this.url, data, config);
    }
  },
  exportFile: {
    // url: `${config.API_URL}/upload/attachment/download`,
    url: `http://localhost:56000/attachment/download`,
    name: "导出附件",
    get: async function (data, config = {}) {
      return await http.get(this.url, data, config);
    }
  },
  importFile: {
    url: `${config.API_URL}/fileImport`,
    name: "导入附件",
    post: async function (data, config = {}) {
      return await http.post(this.url, data, config);
    }
  },
  file: {
    menu: {
      url: `${config.API_URL}/file/menu`,
      name: "获取文件分类",
      get: async function () {
        return await http.get(this.url);
      }
    },
    list: {
      url: `${config.API_URL}/file/list`,
      name: "获取文件列表",
      get: async function (params) {
        return await http.get(this.url, params);
      }
    }
  },
  position: {
    url: `${config.API_URL}/base/hrms/position/find`,
    name: "查询省市地区",
    get: async function (data) {
      return await http.get(this.url, data);
    }
  },

  filterSidebar: {
    name: '侧边栏组件相关接口',
    list: {
      url: `${config.API_URL}/base/hrms/user/favorites/list`,
      name: "获取侧边栏列表",
      post: async function (params) {
        return await http.post(this.url, params);
      }
    },
    save: {
      url: `${config.API_URL}/base/hrms/user/favorites/save`,
      name: "保存侧边栏列表",
      post: async function (params) {
        return await http.post(this.url, params);
      }
    },
    update: {
      url: `${config.API_URL}/base/hrms/user/favorites/update`,
      name: "更新侧边栏列表",
      post: async function (params) {
        return await http.post(this.url, params);
      }
    },
    remove: {
      url: `${config.API_URL}/base/hrms/user/favorites/remove`,
      name: "删除侧边栏列表",
      get: async function (params) {
        return await http.get(this.url, params);
      }
    },

    items: {
      name: '侧边栏详情处理',
      batchAdd: {
        url: `${config.API_URL}/base/hrms/user/favorites/items/batchAdd`,
        name: "批量添加侧边栏自定义收藏夹详情",
        post: async function (params) {
          return await http.post(this.url, params);
        }
      },
      batchDelete: {
        url: `${config.API_URL}/base/hrms/user/favorites/items/batchDelete`,
        name: "批量删除侧边栏自定义收藏夹详情",
        post: async function (params) {
          return await http.post(this.url, params);
        }

      }
    }
  }
}
